import { render, staticRenderFns } from "./FooterNormal.vue?vue&type=template&id=d710322e&"
import script from "./FooterNormal.vue?vue&type=script&lang=js&"
export * from "./FooterNormal.vue?vue&type=script&lang=js&"
import style0 from "./FooterNormal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports